import { useContext } from 'react';

import { ConfigContext } from '../config';

const defaultT: (key: string, interpolations?: Record<string, any>) => string = (key: string) => {
    return key;
};

const useTranslation = () => {
    const { t, currentLanguage } = useContext(ConfigContext);

    return {
        currentLanguage,
        t: t || defaultT
    };
};

export default useTranslation;
